export { RateContainer as RateDetail } from './container';
